import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { ConfigService, ReportService } from 'services';
import queryString from 'query-string';
import { Menu as MenuIcons, CloseIcon, CheckWhiteIcon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Config extends React.Component<Props> {

	state = {
		config_permissions: [],
		form: {
			client_id: (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? this.props.user?.id : ''
		},
		clients: [],
		config: [],
		type: Constants.CONFIG_TYPES.KYC,
		countries: [],
		available_countries: []
	}

	componentDidMount() {
		this.init();
	}

	componentDidUpdate(prevProps: any) {
	  if (this.props.location.pathname !== prevProps.location.pathname) {
	  	this.init();
	  }
	}

	init = async () => {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Configuración',
				onBack: null
			}
		});

		const PATH_TO_TYPE = {
		  verifications: Constants.CONFIG_TYPES.KYC,
		  documents: Constants.CONFIG_TYPES.DOCUMENTS,
		  bills: Constants.CONFIG_TYPES.BILLS
		}

		const { pathname } = this.props.history.location;
		const routeKey = Object.keys(PATH_TO_TYPE).find(key => pathname.includes(key));
		// @ts-ignore
		const type: number = routeKey ? PATH_TO_TYPE[routeKey] : 0;

		const _params = queryString.parse(this.props.location.search);
    	this.props.history.replace(this.props.location.pathname);

    	if (_params.user_id) {
    		await this.setState({
    			form: {
    				...this.state.form,
    				client_id: _params.user_id
    			}
    		});
    	}

		// @ts-ignore
		if (!type || [Constants.CONFIG_TYPES.KYC,Constants.CONFIG_TYPES.DOCUMENTS,Constants.CONFIG_TYPES.BILLS].indexOf(type) == -1) {
			this.props.history.replace('/');
		}
		else {
			let icon = '';
			let color = '';
			let subtitle = '';

			switch(type) {
				case Constants.CONFIG_TYPES.KYC:
					subtitle = 'Gestiona la configuración de las verificaciones de KYC.';
					icon = MenuIcons.Menu9;
					color = '#ebf9f2';
				break;

				case Constants.CONFIG_TYPES.DOCUMENTS:
					subtitle = 'Gestiona la configuración de las verificaciones de documentos.';
					icon = MenuIcons.Menu5;
					color = '#f1f3fd';
				break;

				case Constants.CONFIG_TYPES.BILLS:
					subtitle = 'Gestiona la configuración de las verificaciones de facturas.';
					icon = MenuIcons.Menu6;
					color = '#edf0fe';
				break;
			}

			this.props.dispatch({
				type: 'SET_HEADER',
				payload: {
					title: 'Configuración',
					onBack: null,
					subtitle,
					icon,
					color
				}
			});

			this.setState({
				type
			},() => {
				this.load();
				if (this.props.user?.level_id == Constants.LEVELS.ADMIN || this.props.user?.level_id == Constants.LEVELS.MODERATOR) {
					this.loadClients();
				}
			});			
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ConfigService.get({
			type: this.state.type,
			...this.state.form
		});
		this.setState({
			config_permissions: res.config_permissions || [],
			config: res.config || [],
			countries: res.countries || [],
			available_countries: res.available_countries || []
		});
	}

	save = (item: any) => {
		Globals.confirm('¿Desea cambiar el estatus del permiso?',async () => {
			await ConfigService.save({
				config_permission_id: item?.id,
				...this.state.form
			});
			Globals.showSuccess("Se ha cambiado la configuración correctamente");
			this.load(true);
		});
	}

	saveCountry = (item: any) => {
		Globals.confirm('¿Desea cambiar el estatus del país?',async () => {
			await ConfigService.saveCountry({
				country_id: item?.id,
				...this.state.form
			});
			Globals.showSuccess("Se ha cambiado la configuración correctamente");
			this.load(true);
		});
	}

	loadClients = async () => {
		const res: any = await ReportService.admin.getClients({
			withoutLoading: true,
			only_actives: true,
			config_type: this.state.type
		});
		this.setState({
			clients: res.clients || []
		});
	}

	render() {
		let action = '';

		switch(this.state.type) {
			case Constants.CONFIG_TYPES.KYC:
				action = 'verificación';
			break;

			case Constants.CONFIG_TYPES.DOCUMENTS:
				action = 'documentos';
			break;

			case Constants.CONFIG_TYPES.BILLS:
				action = 'facturas';
			break;
		}

		return (
			<div id="config">
				{
					(this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? (
						<p className="warning">Advertencia: Inactivar estos servicios deshabilita la función seleccionada para su cuenta. Para un correcto funcionamiento deben estar en estatus "Activo"</p>
					) : (
						<div className="row">
							<div className="col-md-3">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Usuario"
									name="client_id"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.client_id }
									options={ this.state.clients.map((item: any) => {
										return {
											value: item.id,
											label: item?.name + ' ' + item?.lastname
										}
									}) } />
								<p className="warning">Por favor, seleccione un usuario para continuar</p>
							</div>
						</div>
					)
				}

				{
					this.state.form.client_id != '' && (
						<div className="container-white">
							<div className="container-title">
								<div className="container-icon">
									<img src={ MenuIcons.Menu8 } />
								</div>
								<div>
									<p className="bold">Acciones de { action }</p>
									<p>Administra las acciones y su estado.</p>
								</div>
							</div>

							<Table header={ [this.state.type == Constants.CONFIG_TYPES.KYC ? 'Acción' : 'Documento','Estado'] } data={ this.state.config_permissions.length }>
								{
									this.state.config_permissions?.map((item: any) => {
										const config: any = this.state.config.find((i: any) => i.permission_id == item.id);

										return (
											<tr>
												<td>
													<div className="container-name">
														<div className="container-icon">
															<img src={ Constants.BASE_PUBLIC + item.icon } />
														</div>
														<p>{ item?.name }</p>
													</div>
												</td>
												<td>
													<a href="#" className={ `status ${ (!config || config.status) ? 'green' : 'red' }` } onClick={ (e: any) => {
														e.preventDefault();
														if (checkPermission(Constants.MODULES.CONFIG,'write') || checkPermission(Constants.MODULES.ADMIN_CONFIG,'write')) {
															this.save(item);
														}
													} }>
														<img src={ (!config || config.status) ? CheckWhiteIcon : CloseIcon } className={ (!config || config.status) ? 'green' : 'red' } />
														{ (!config || config.status) ? 'Activo' : 'Desactivado' }
													</a>
												</td>
											</tr>
										)
									})
								}
							</Table>
						</div>
					)
				}

				{
					this.state.form.client_id != '' && this.state.type == Constants.CONFIG_TYPES.KYC && (
						<div className="container-white">
							<div className="container-title">
								<div className="container-icon">
									<img src={ MenuIcons.Menu8 } />
								</div>
								<div>
									<p className="bold">Países aceptados (Verificación genérica)</p>
									<p>Selecciona los países permitidos. Si la lista está vacía, se aceptarán documentos de todos los países.</p>
								</div>
							</div>

							<Table header={ ['País','Estado'] } data={ this.state.countries?.length }>
								{
									this.state.countries?.map((item: any) => {
										const is_active = this.state.available_countries?.find((i: any) => i.country_id == item?.id);

										return (
											<tr>
												<td>
													<div className="container-name">
														<p>{ item?.name }</p>
													</div>
												</td>
												<td>
													<a href="#" className={ `status ${ is_active ? 'green' : 'red' }` } onClick={ (e: any) => {
														e.preventDefault();
														if (checkPermission(Constants.MODULES.CONFIG,'write') || checkPermission(Constants.MODULES.ADMIN_CONFIG,'write')) {
															this.saveCountry(item);
														}
													} }>
														<img src={ is_active ? CheckWhiteIcon : CloseIcon } className={ is_active ? 'green' : 'red' } />
														{ is_active ? 'Activo' : 'Desactivado' }
													</a>
												</td>
											</tr>
										)
									})
								}
							</Table>
						</div>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Config);